module.exports = __webpack_public_path__ + "static/media/icon-circle-check-green.24fb0acd.svg";